<div class="layout-footer">
    <span class="layout-footer__mark"><i class="pi pi-heart-fill"></i></span>
    <span>Powered &amp; Developed by <strong>Health Information &amp; Service Delivery Unit (HISDU)</strong></span>
</div>
